import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

const ALERT_CONFIG = [
    { key: "uploadNPWP",   title: "File NPWP Belum di Upload",       type: "danger" },
    { key: "uploadKTP",    title: "File KTP Belum di Upload",         type: "danger" },
    { key: "uploadNIB",    title: "File NIB Belum di Upload",         type: "danger" },
    { key: "fileTooLarge", title: "Ukuran file maksimal 1MB. Kompres file sebelum upload", type: "danger" }, 
    { key: "pilihService", title: "Jenis Layanan Belum Dipilih",      type: "danger" },
    { key: "pilihUPT",     title: "UPT belum dipilih",                type: "danger" },
    { key: "validCaptcha", title: "Kode Security Tidak Sesuai",       type: "danger" },
    { key: "existingUser", title: "Username tidak tersedia",                           type: "danger"  },
    { key: "existingNPWP", title: "NPWP sudah terdaftar, hubungi admin atau login",  type: "warning" },
    { key: "tradeFound",   title: "Pengguna Jasa Sudah Terdaftar, Silahkan hubungi UPT BPPMKHP terkait untuk informasi lebih lanjut.",                 type: "info"   },
    { key: "serverError",  title: "Terjadi kesalahan, silakan coba beberapa saat lagi", type: "danger" },
    { key: "belumSetuju", title: "Anda harus menyetujui syarat dan ketentuan terlebih dahulu", type: "danger" },
];

const AlertManager = ({ alerts, setAlert, onSelesai, onTradeFound }) => {
    return (
        <>
            {ALERT_CONFIG.map(({ key, title, type }) =>
                alerts[key] ? (
                    <SweetAlert
                        key={key}
                        title={title}
                        {...{ [type]: true }}
                        onConfirm={() =>
                            key === "tradeFound"
                                ? onTradeFound()
                                : setAlert(key, false)
                        }
                        btnSize="sm"
                    />
                ) : null
            )}

            {alerts.selesai && (
                <SweetAlert
                    title="Registrasi Berhasil"
                    success
                    onConfirm={onSelesai}
                    btnSize="sm"
                >
                    Terima kasih telah melakukan registrasi, konfirmasi user akan
                    dikirimkan melalui email terdaftar
                </SweetAlert>
            )}
        </>
    );
};

export default AlertManager;